// Pure wrapper for Excel export logic - restores original Excel styling behavior
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { createCellCustomizer } from './cellCustomizerPdf'; // reuse same customizer for excelCell behavior
// eslint-disable-next-line no-unused-vars
import { PDF_STYLES } from './pdfStyles';

// eslint-disable-next-line no-unused-vars
export async function exportAsExcel({ e, fileName, grid, finalColumnsForExport, formatCellValue, options, exportVisibilityMap }) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');


    const cellCustomizer = createCellCustomizer({ formatCellValue });


    await exportDataGrid({
        component: e.component,
        worksheet,
        customizeColumns: (columns) => {
            columns.forEach((col) => {
                const dataField = col.gridColumn && col.gridColumn.dataField;
                if (dataField) {
                    // Leaf column: use the visibility map; hide action/unknown columns not in the list
                    col.visible = exportVisibilityMap.has(dataField)
                        ? exportVisibilityMap.get(dataField)
                        : false;
                }
                // Band/group columns (no dataField): leave as-is so DevExtreme shows/hides them
                // automatically based on child visibility
            });
        },
        customizeCell: ({ excelCell, gridCell }) => {
            // adapt options shape expected by cellCustomizer: { excelCell, gridCell }
            const fakeOptions = { excelCell, gridCell };
            cellCustomizer(fakeOptions);


            // Additional Excel-specific tweaks
            if (gridCell && gridCell.rowType === 'header') {
                excelCell.font = Object.assign({}, excelCell.font, { bold: true, size: 10 });
            }
        },
    });


    // auto-fit columns (approx)
    worksheet.columns.forEach(function (column) {
        var dataMax = 0;
        column.values.forEach((element) => {
            if (element) {
                var cellLength = element.toString().length;
                if (cellLength > dataMax) dataMax = cellLength;
            }
        });
        column.width = dataMax < 10 ? 10 : dataMax + 5;
    });


    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
}